import Rule from "../Rule";
import OrderActivity from "../../Crud/OrderActivity";

const insuranceSubTypeIdsRequiringE1028 = [
    211, // Superior Health MCD Replacement
    219, // Meridian Health IL MCD Replacement
];
const specificHcpcsCodes = new Set(["E1032", "E1033", "E1034"]);

export default class RuleE1028HcpcsRequiredToEnableDSWOButton extends Rule {
    static message = "DSWO cannot be generated for this insurance when E1032, E1033, or E1034 is present. Please use E1028.";

    run() {
        // Read the active order activity record from chart-shaped rule input.
        const currentChartData = this.currentChartData?.orderActivity?.[this.orderActivityId];

        if (!currentChartData) {
            return this.pass();
        }

        // Business Support can bypass DSWO gating rules.
        // 96 = Business Support: Followup, 116 = Business Support
        if ([96, 116].includes(currentChartData.orderStatusReasonId)) {
            return this.pass();
        }

        // Normalize order HCPCS codes once for case-insensitive set membership checks.
        const products = OrderActivity.getProducts(currentChartData, this.currentChartData)
            .map(orderActivityProduct => this.currentChartData.product?.[orderActivityProduct.id])
            .filter(product => product?.deleted !== true);
        const hcpcsCodes = new Set(
            products.map(product => product.hcpcs?.toUpperCase()?.trim())
        );

        // This rule only applies to plans that require E1028 instead of E1032/3/4.
        if (!insuranceSubTypeIdsRequiringE1028.includes(currentChartData.insuranceSubTypeId)) {
            return this.pass();
        }

        // Fail when any disallowed specific swingaway code exists for these plans.
        if (Array.from(specificHcpcsCodes).some(code => hcpcsCodes.has(code))) {
            return this.fail();
        }

        return this.pass();
    }
}
